import React from "react";

export interface User {
    id?: number | string;
    uid?: string;
    name?: string;
    lastname?: string;
    email?: string;
    cards?: any[];
    dui?: string;
    phone?: string;
    photo?: string;
    image?: string;
    ticketsBanner?: string;
}

export interface Config {
    countryCode: string;
    storeKey: string;
    adminCostStore?: any;
    [key: string]: any;
}

export interface EventData {
    id?: string | number;
    activeZoneSelector?: boolean;
    [key: string]: any;
}

export interface OrderData {
    numeredSeats?: boolean;
    admin_costs_visible?: boolean;
    admin_costs_value?: any;
    $key?: string;
    [key: string]: any;
}

export interface ModalProp {
    modalFucntion: (typeModal:string) => void;
}

export interface ContextModel {
    user: User;
    event: EventData;
    order: OrderData;
    config: Config;
    events: EventData[];
    
    asignateOrderData: (order: OrderData) => void;
    asignateEventData: (event: EventData) => void;
    asignateUser: (user: User) => void;
    asignateConfig: (config: Config) => void;
    asignateEventsArray: (events: EventData[]) => void;
}

const UserContextProvider = React.createContext<ContextModel>({
    user: {
        id: 0,
        name: "",
        lastname: "",
        email: "",
        cards: [],
        dui: "",
        phone: "",
        photo: "",
        ticketsBanner: "",
    },
    config: { countryCode: "", storeKey: "" },
    event: {},
    order: {},
    events: [],
    asignateEventsArray: (events: EventData[]) => { },
    asignateOrderData: (order: OrderData) => { },
    asignateEventData: (event: EventData) => { },
    asignateUser: (user: User) => {},
    asignateConfig: (config: Config) => { }
});

export default UserContextProvider;